import { useGlobalContext } from '../context'

function Vampire() {
    const { players, index, voteForKill, vote, openWaitingScreen, turns } = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Vampire)</h4>
            <p className='text-center'>You are a vampire!You can select a non-vampire player to kill each round.At the end of the round ,player with the most votes that you and your vampire accomplices (if you have any)
             have chosen to kill,is going to (hopefully) die!You better don't let them villagers win, you are fucking vampire dude!</p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (player.class === 'vampire' || player.class === 'foolvampire' || player.class === 'dracula')
                            return (<button className='btn btn-danger border' disabled='disabled' key={index}>{player.name}</button>)
                        else 
                            return (<button disabled={vote ? 'disabled' : ''} className={turns === 0 ? 'hidden' : 'btn btn-dark'} onClick={(e) => { voteForKill(index); e.target.classList.add('selected')}} key={index}>{`${player.name}(${player.voteCount})`}</button>)
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Vampire;